var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import './approval-item-details.css';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { formatCurrency } from '../util/format-currency';
import ApprovalItemDetailsAPI from './approval-item-details-api';
let ApprovalItemDetails = class ApprovalItemDetails extends Component {
    render() {
        const { approvationNumber, proccessNumber, origin, situation, dsSituation, reason, deliveryDate, requester, totalApprovalValue, dsOrigin, originStock, targetStock, observation, } = this.props;
        const deliveryDateFormated = ModelService.format('date', deliveryDate, { type: 'date' });
        const numTotalApprovalValue = Number(totalApprovalValue) || 0;
        return (React.createElement("div", { className: "approval-item-details" },
            React.createElement("div", { className: "approval-item-details__info" },
                React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approvals.label'),
                    ":",
                    approvationNumber,
                    "  ",
                    MessageService.translate('approvals.table-header-process-id'),
                    ": ",
                    proccessNumber),
                React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approval.type.document'),
                    ": ",
                    dsOrigin),
                React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approvals.table-header-approval-date'),
                    ": ",
                    deliveryDateFormated),
                origin == 'R' && (React.createElement("div", null,
                    originStock && (React.createElement("div", { className: "approval-list-card__info-value" },
                        React.createElement("span", { className: "approval-list-card__info-label" },
                            MessageService.translate('approvals.table-header-origin-stock'),
                            ":"),
                        " ",
                        originStock)),
                    targetStock && (React.createElement("div", { className: "approval-list-card__info-value" },
                        React.createElement("span", { className: "approval-list-card__info-label" },
                            MessageService.translate('approvals.table-header-target-stock'),
                            ":"),
                        " ",
                        targetStock)))),
                (origin == 'O' || origin == 'S') && numTotalApprovalValue > 0 && (React.createElement("div", { className: "approval-item-detail__value" },
                    MessageService.translate('approval.total-value'),
                    ": ",
                    formatCurrency(numTotalApprovalValue))),
                requester && (React.createElement("div", { className: "approval-item-details__info-value" },
                    MessageService.translate('approvals.requester'),
                    ": ",
                    requester))),
            React.createElement("div", { className: "approval-item-details__situation" },
                React.createElement("div", { className: "approval-item-details__info border-1" },
                    React.createElement("div", null,
                        React.createElement("span", { className: "approval-item-details__info-value bold" },
                            MessageService.translate('approvals.filtered-list-situation'),
                            ":"),
                        React.createElement("span", null,
                            ' ',
                            situation)),
                    dsSituation === 'PENDING' && (React.createElement("div", null,
                        React.createElement("span", { className: "approval-item-details__info-value bold" },
                            MessageService.translate('approval.pending.reason'),
                            ":"),
                        React.createElement("span", null,
                            ' ',
                            reason))),
                    observation != null && observation !== '' && (React.createElement("div", null,
                        " ",
                        React.createElement("span", { className: "approval-item-details__info-value bold" },
                            MessageService.translate('approval.pending.observation'),
                            ":"),
                        React.createElement("span", null,
                            ' ',
                            observation)))))));
    }
};
ApprovalItemDetails.propTypes = {
    approvationNumber: number,
    proccessNumber: string,
    origin: string,
    situation: string,
    dsSituation: string,
    reason: string,
    deliveryDate: string,
    requester: string,
    documentNumber: number,
    totalApprovalValue: number,
    dsOrigin: string,
    originStock: string,
    targetStock: string,
    observation: string,
};
ApprovalItemDetails = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ApprovalItemDetailsAPI })
], ApprovalItemDetails);
export default ApprovalItemDetails;
//# sourceMappingURL=approval-item-details.js.map